<script>
import router from "@/router";
import push from "@/components/Menu/push.vue";
import http from "@/plugins/axios";

export default {
  name: 'new-menu-app',
  data: () => ({
    searchdialog : false,
    search : {
      data : []
    },
    value_search : "",
  }),
  computed: {
    push() {
      return push
    }
  },
  methods:{
    showproduct(id){
      router.push("/product/"+id)
    },
    getsearch(){
      if(this.value_search.length>=2){
        const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
        http.get("/products/search/"+this.value_search, { headers: { Authorization: AuthStr } })
            .then(response => {
              this.search = response.data;
            })
            .catch((error) => {
            });
      }
    },
    showSearch(){
      this.searchdialog = true;
    },
    showmenu(){
      $("#menu").fadeIn();
    },
    closemenu(){
      $("#menu").fadeOut();
    }
  },
  props: [
    "revese",
  ],
}
</script>

<template>
  <i v-if="revese" class="fa-regular fa-bars revese" @click="showmenu"></i>
  <i v-else class="fa-regular fa-bars " @click="showmenu"></i>
  <div class="poab" id="menu">
    <i class="fa-regular fa-close closeMenu" @click="closemenu"></i>
    <h3>منو</h3>
    <ul>
      <a href="/home">
        <li>صفحه اصلی</li>
      </a>
      <a href="/profile">
        <li>ویرایش کاربر</li>
      </a>
      <a href="/heart">
        <li >نشان شده ها</li>
      </a>
      <a href="/orders">
      <li >سفارشات</li>
      </a>
      <a href="/cart">
        <li>سبد خرید</li>
      </a>
      <a href="/bestseller">
        <li> پرفروش ترین ها</li>
      </a>
      <li>ارتباط با ما</li>
      <a href="/logout">
        <li>خروج از حساب کاربری</li>
      </a>
    </ul>
  </div>
</template>

<style scoped>
.search{
  text-align: center;
  margin-top: 5px;
}
.search i{
  font-size: 12pt !important;
  color: #000 !important;
  margin-right: -28px;
}
.closeMenu{
  left: 10px;
  top: 10px;
  position: absolute;
}
.toolbar i{
  font-size: 24pt;
  color: #1fa29d;
}
.toolbar i.revese{
  color: #fff;
}
.poab{
  display: none;
  width: 100vw;
  height: 100vh;
  background: rgba(255,255,255,0.8);
  z-index: 1000;
  top:0;
  position: absolute;
  right: 0;
}
.poab h3{
  text-align: center;
  color: #1fa29d;
  margin-top: 20px;
}
ul{
  width: 100%;
  text-align: center;
  color: #1fa29d;
  list-style: none;
  font-weight: 800;
  margin-top: 300px;
  padding: 0 !important;
}
ul li{
  margin: 10px auto;
}
a{
  color: #1fa29d;
  text-decoration: none;
}
a:hover{
  color: #005956;
}
</style>